import {Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {ContentTextItem} from 'src/api/cargo-c2c/types'

import {classes} from './TextItem.classes'
import {colorMap, typographyMap} from './TextItem.consts'

type Props = {
  item: ContentTextItem
}
const imageRegex = /\[(.*?)\]\((.*?)\)/

export const TextItem: React.FC<Props> = ({item}) => {
  const parts = item.text.split('\n')

  return (
    <Typography color={colorMap[item.color]} Component="div" variant={typographyMap[item.typography] || 'body2'}>
      <div className={classes.container}>
        {parts.map((part, index) => {
          const match = part.match(imageRegex)
          if (match) {
            return (
              <a key={index} href={match[2]} rel="noreferrer" target="_blank">
                <img alt={match[1]} className={classes.photo} src={match[2]} />
              </a>
            )
          } else {
            return (
              <span key={index} className={classes.container}>
                {part}
              </span>
            )
          }
        })}
      </div>
    </Typography>
  )
}
